// 
import WebComponent from '../webComponents/WebComponent';

export default class CloseableAlert extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }
  didMount() {
    this.buildCloseLink();
  }
  buildCloseLink() {
    this.closeLink = document.createElement('a');
    this.element.append(this.closeLink);
    this.closeLink.classList.add('alert-group__close');
    this.closeLink.setAttribute('title', this.i18n('title'));
    this.closeLink.addEventListener('click', this.handleClose);

    // create svg icon
    const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgIcon.classList.add('svg-icon');

    const svgLink = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    svgLink.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/img/svg/svg-sprite.svg#close-thin');
    svgIcon.appendChild(svgLink);
    this.closeLink.appendChild(svgIcon);

  }
  handleClose(e) {
    e.preventDefault();
    this.element.remove();
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/CloseableAlert.js